var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoConstructoraBaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1940",
    "data-name": "Group 1940",
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.373,
    height: 51.691,
    viewBox: "0 0 227.373 51.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1935",
    "data-name": "Group 1935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M1343.011,1154.3h34.219v30.2h-30.56a3.659,3.659,0,0,1-3.659-3.659Zm69.667,0h-34.1v30.2h30.444a3.659,3.659,0,0,0,3.659-3.659Z",
    transform: "translate(-1343.011 -1132.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M1377.23,1134.225v20.1h-34.219Zm1.347,0v20.1h34.1Z",
    transform: "translate(-1343.011 -1134.225)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1939",
    "data-name": "Group 1939",
    transform: "translate(75.98 21.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1936",
    "data-name": "Group 1936",
    transform: "translate(14.087 22.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M1433.821,1181.755a3.948,3.948,0,1,1-.011-5.373l-.671.594a2.644,2.644,0,0,0-2.159-1.068c-1.541,0-2.72,1.254-2.72,3.16s1.179,3.214,2.72,3.214a2.728,2.728,0,0,0,2.2-1.09Z",
    transform: "translate(-1427.293 -1175.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M1444.4,1179.068a3.822,3.822,0,1,1-3.821-3.942A3.77,3.77,0,0,1,1444.4,1179.068Zm-6.673,0a2.877,2.877,0,1,0,5.715,0,2.872,2.872,0,1,0-5.715,0Z",
    transform: "translate(-1426.643 -1175.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M1454.262,1175.3v7.817h-.089l-4.822-5.483-.352-.451.033.55v5.164h-.9v-7.817h.088l4.735,5.329.451.572-.044-.671v-5.01Z",
    transform: "translate(-1425.863 -1175.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M1460.492,1175.126a2.972,2.972,0,0,1,2.39,1.046l-.6.562a2.09,2.09,0,0,0-1.761-.859c-.914,0-1.443.463-1.443,1.178,0,.914.826,1.212,1.707,1.563.991.4,2.059.849,2.059,2.29,0,1.509-1.079,2.147-2.511,2.147a3.165,3.165,0,0,1-2.7-1.408l.65-.485a2.423,2.423,0,0,0,2.037,1.167c1.31,0,1.652-.715,1.652-1.387,0-.947-.816-1.277-1.685-1.629-1-.408-2.081-.826-2.081-2.2A2.009,2.009,0,0,1,1460.492,1175.126Z",
    transform: "translate(-1425.21 -1175.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M1471.177,1175.281v.793h-2.312v6.8h-.914v-6.8h-2.346v-.793Z",
    transform: "translate(-1424.663 -1175.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M1474.561,1175.285c.507-.022,1.442-.056,1.981-.056,1.783,0,2.676.815,2.676,2.169a2.121,2.121,0,0,1-1.443,2.213l2.389,3.27h-1.046l-2.257-3.083c-.231.022-.429.033-.639.033a5.74,5.74,0,0,1-.771-.044v3.094h-.891Zm.891,3.743a7.274,7.274,0,0,0,.969.066c1.046,0,1.894-.419,1.894-1.619,0-.77-.341-1.5-1.74-1.5-.374,0-.947.044-1.123.054Z",
    transform: "translate(-1424.048 -1175.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M1483.935,1179.8c0,1.663.65,2.489,2,2.489s2.015-.826,2.015-2.489v-4.514h.924v4.238c0,1.366-.176,3.523-2.95,3.523s-2.907-2.2-2.907-3.523v-4.238h.914Z",
    transform: "translate(-1423.468 -1175.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M1499.2,1181.755a3.948,3.948,0,1,1-.011-5.373l-.672.594a2.644,2.644,0,0,0-2.158-1.068c-1.542,0-2.72,1.254-2.72,3.16s1.178,3.214,2.72,3.214a2.728,2.728,0,0,0,2.2-1.09Z",
    transform: "translate(-1422.806 -1175.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M1507.522,1175.281v.793h-2.312v6.8h-.914v-6.8h-2.345v-.793Z",
    transform: "translate(-1422.169 -1175.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M1517.589,1179.068a3.823,3.823,0,1,1-3.822-3.942A3.77,3.77,0,0,1,1517.589,1179.068Zm-6.673,0a2.877,2.877,0,1,0,5.714,0,2.872,2.872,0,1,0-5.714,0Z",
    transform: "translate(-1421.62 -1175.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M1521.313,1175.285c.506-.022,1.443-.056,1.982-.056,1.783,0,2.676.815,2.676,2.169a2.122,2.122,0,0,1-1.443,2.213l2.39,3.27h-1.046l-2.257-3.083c-.232.022-.43.033-.639.033a5.729,5.729,0,0,1-.77-.044v3.094h-.892Zm.892,3.743a7.273,7.273,0,0,0,.968.066c1.046,0,1.895-.419,1.895-1.619,0-.77-.342-1.5-1.74-1.5-.374,0-.947.044-1.123.054Z",
    transform: "translate(-1420.84 -1175.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M1534.763,1175.281v.793h-3.612v2.477h3.018v.781h-3.018v2.763h3.81v.782h-4.723v-7.6Z",
    transform: "translate(-1420.227 -1175.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M1540.539,1175.126a2.971,2.971,0,0,1,2.39,1.046l-.6.562a2.089,2.089,0,0,0-1.761-.859c-.913,0-1.442.463-1.442,1.178,0,.914.826,1.212,1.706,1.563.992.4,2.059.849,2.059,2.29,0,1.509-1.08,2.147-2.51,2.147a3.166,3.166,0,0,1-2.7-1.408l.65-.485a2.425,2.425,0,0,0,2.037,1.167c1.311,0,1.652-.715,1.652-1.387,0-.947-.815-1.277-1.684-1.629-1-.408-2.082-.826-2.082-2.2A2.009,2.009,0,0,1,1540.539,1175.126Z",
    transform: "translate(-1419.716 -1175.072)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1938",
    "data-name": "Group 1938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M1420.3,1169.488h-6.193v-14.146h5.5a7.927,7.927,0,0,1,2.479.344,3.567,3.567,0,0,1,1.569.931,3.663,3.663,0,0,1,.951,2.469,2.9,2.9,0,0,1-1.073,2.47,3.856,3.856,0,0,1-.505.354c-.1.047-.264.125-.507.233a3.706,3.706,0,0,1,2.095,1.184,3.3,3.3,0,0,1,.779,2.236,3.808,3.808,0,0,1-1.011,2.611Q1423.217,1169.488,1420.3,1169.488Zm-3.035-8.419h1.5a5.064,5.064,0,0,0,1.952-.283,1.2,1.2,0,0,0,.638-1.225,1.264,1.264,0,0,0-.587-1.244,4.648,4.648,0,0,0-1.983-.3h-1.517Zm0,5.747h2.165a4.791,4.791,0,0,0,2.034-.333,1.323,1.323,0,0,0,.677-1.315,1.266,1.266,0,0,0-.718-1.3,6.148,6.148,0,0,0-2.3-.314h-1.861Z",
    transform: "translate(-1414.111 -1154.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M1426.607,1157.29a1.807,1.807,0,1,1,1.265.516A1.72,1.72,0,0,1,1426.607,1157.29Zm2.783,12.273h-3.035v-10.887h3.035Z",
    transform: "translate(-1413.289 -1154.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M1440.8,1167.712a6.087,6.087,0,0,1-4.321,1.74,5.736,5.736,0,0,1-4.1-1.527,5.368,5.368,0,0,1-1.618-4.1,5.283,5.283,0,0,1,1.649-4.088,5.563,5.563,0,0,1,3.9-1.518,5.632,5.632,0,0,1,3.815,1.356,4.665,4.665,0,0,1,1.568,3.724v1.618h-7.933a2.164,2.164,0,0,0,.931,1.458,2.977,2.977,0,0,0,1.781.566,3.489,3.489,0,0,0,2.63-1.072Zm-2.914-6.456a2.3,2.3,0,0,0-1.528-.526,2.736,2.736,0,0,0-1.649.546,2.091,2.091,0,0,0-.87,1.477h4.776A2.156,2.156,0,0,0,1437.885,1161.256Z",
    transform: "translate(-1412.968 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M1445.531,1163.219v6.071H1442.5V1158.4h3.036v1.214a4.25,4.25,0,0,1,3.1-1.4,3.833,3.833,0,0,1,2.884,1.215,4.481,4.481,0,0,1,1.164,3.238v6.617h-3.036v-6.152q0-2.509-1.841-2.509a2.21,2.21,0,0,0-1.589.657A2.573,2.573,0,0,0,1445.531,1163.219Z",
    transform: "translate(-1412.163 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M1463.528,1167.635a6.087,6.087,0,0,1-4.321,1.741,5.736,5.736,0,0,1-4.1-1.528,5.366,5.366,0,0,1-1.619-4.1,5.284,5.284,0,0,1,1.65-4.088,5.562,5.562,0,0,1,3.9-1.517,5.634,5.634,0,0,1,3.815,1.356,4.663,4.663,0,0,1,1.568,3.723v1.619h-7.933a2.161,2.161,0,0,0,.931,1.457,2.979,2.979,0,0,0,1.781.567,3.49,3.49,0,0,0,2.63-1.073Zm-2.914-6.456a2.3,2.3,0,0,0-1.528-.526,2.733,2.733,0,0,0-1.649.546,2.092,2.092,0,0,0-.87,1.478h4.776A2.159,2.159,0,0,0,1460.614,1161.18Z",
    transform: "translate(-1411.408 -1153.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M1473.746,1165.9a3.168,3.168,0,0,1-1.184,2.58,4.58,4.58,0,0,1-3,.971,8.028,8.028,0,0,1-2.53-.435,7.443,7.443,0,0,1-2.367-1.285l1.334-1.9a5.823,5.823,0,0,0,3.623,1.316,1.641,1.641,0,0,0,.931-.233.712.712,0,0,0,.344-.618.891.891,0,0,0-.475-.708,5.414,5.414,0,0,0-1.376-.607c-.6-.188-1.059-.351-1.375-.485a7.637,7.637,0,0,1-1.083-.587,2.512,2.512,0,0,1-1.235-2.277,2.984,2.984,0,0,1,1.215-2.459,4.936,4.936,0,0,1,3.136-.951,6.846,6.846,0,0,1,3.845,1.3l-1.134,2.024a4.965,4.965,0,0,0-2.822-.972q-1.408,0-1.406.769a.74.74,0,0,0,.445.668,9.087,9.087,0,0,0,1.478.566q1.031.324,1.466.5a7.227,7.227,0,0,1,1.043.536A2.472,2.472,0,0,1,1473.746,1165.9Z",
    transform: "translate(-1410.642 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M1502.921,1169.488h-6.192v-14.146h5.5a7.924,7.924,0,0,1,2.478.344,3.559,3.559,0,0,1,1.569.931,3.664,3.664,0,0,1,.951,2.469,2.9,2.9,0,0,1-1.073,2.47,3.866,3.866,0,0,1-.505.354c-.094.047-.263.125-.505.233a3.714,3.714,0,0,1,2.094,1.184,3.3,3.3,0,0,1,.779,2.236,3.806,3.806,0,0,1-1.012,2.611Q1505.834,1169.488,1502.921,1169.488Zm-3.035-8.419h1.5a5.07,5.07,0,0,0,1.953-.283,1.2,1.2,0,0,0,.637-1.225,1.265,1.265,0,0,0-.587-1.244,4.644,4.644,0,0,0-1.983-.3h-1.517Zm0,5.747h2.165a4.794,4.794,0,0,0,2.034-.333,1.324,1.324,0,0,0,.678-1.315,1.266,1.266,0,0,0-.719-1.3,6.147,6.147,0,0,0-2.3-.314h-1.862Z",
    transform: "translate(-1408.44 -1154.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M1509.224,1157.29a1.808,1.808,0,1,1,1.265.516A1.723,1.723,0,0,1,1509.224,1157.29Zm2.783,12.273h-3.035v-10.887h3.035Z",
    transform: "translate(-1407.618 -1154.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M1523.416,1167.712a6.083,6.083,0,0,1-4.32,1.74,5.733,5.733,0,0,1-4.1-1.527,5.365,5.365,0,0,1-1.619-4.1,5.282,5.282,0,0,1,1.649-4.088,5.563,5.563,0,0,1,3.9-1.518,5.628,5.628,0,0,1,3.814,1.356,4.665,4.665,0,0,1,1.569,3.724v1.618h-7.934a2.169,2.169,0,0,0,.931,1.458,2.98,2.98,0,0,0,1.781.566,3.494,3.494,0,0,0,2.631-1.072Zm-2.913-6.456a2.3,2.3,0,0,0-1.528-.526,2.735,2.735,0,0,0-1.65.546,2.091,2.091,0,0,0-.87,1.477h4.776A2.153,2.153,0,0,0,1520.5,1161.256Z",
    transform: "translate(-1407.297 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M1528.148,1163.219v6.071h-3.035V1158.4h3.035v1.214a4.251,4.251,0,0,1,3.1-1.4,3.832,3.832,0,0,1,2.883,1.215,4.481,4.481,0,0,1,1.164,3.238v6.617h-3.036v-6.152q0-2.509-1.841-2.509a2.206,2.206,0,0,0-1.588.657A2.57,2.57,0,0,0,1528.148,1163.219Z",
    transform: "translate(-1406.492 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M1546.145,1167.712a6.083,6.083,0,0,1-4.321,1.74,5.732,5.732,0,0,1-4.1-1.527,5.365,5.365,0,0,1-1.619-4.1,5.283,5.283,0,0,1,1.649-4.088,5.563,5.563,0,0,1,3.9-1.518,5.63,5.63,0,0,1,3.814,1.356,4.665,4.665,0,0,1,1.569,3.724v1.618H1539.1a2.165,2.165,0,0,0,.931,1.458,2.98,2.98,0,0,0,1.782.566,3.494,3.494,0,0,0,2.631-1.072Zm-2.913-6.456a2.3,2.3,0,0,0-1.529-.526,2.736,2.736,0,0,0-1.65.546,2.092,2.092,0,0,0-.87,1.477h4.776A2.151,2.151,0,0,0,1543.232,1161.256Z",
    transform: "translate(-1405.738 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M1556.364,1165.9a3.171,3.171,0,0,1-1.184,2.58,4.583,4.583,0,0,1-3.005.971,8.029,8.029,0,0,1-2.531-.435,7.457,7.457,0,0,1-2.367-1.285l1.336-1.9a5.819,5.819,0,0,0,3.622,1.316,1.639,1.639,0,0,0,.931-.233.713.713,0,0,0,.344-.618.891.891,0,0,0-.476-.708,5.407,5.407,0,0,0-1.375-.607q-.9-.282-1.376-.485a7.7,7.7,0,0,1-1.082-.587,2.513,2.513,0,0,1-1.234-2.277,2.983,2.983,0,0,1,1.214-2.459,4.938,4.938,0,0,1,3.136-.951,6.842,6.842,0,0,1,3.845,1.3l-1.133,2.024a4.971,4.971,0,0,0-2.823-.972q-1.407,0-1.406.769a.741.741,0,0,0,.444.668,9.093,9.093,0,0,0,1.478.566q1.032.324,1.467.5a7.274,7.274,0,0,1,1.042.536A2.473,2.473,0,0,1,1556.364,1165.9Z",
    transform: "translate(-1404.971 -1153.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1937",
    "data-name": "Group 1937",
    transform: "translate(69.474 1.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M1483.7,1169.459a5.072,5.072,0,0,1-3.242-1.058,3.5,3.5,0,0,1-1.339-2.9q0-2.194,3.184-3.9a9.155,9.155,0,0,1-1.116-1.495,3.034,3.034,0,0,1-.32-1.475,2.776,2.776,0,0,1,1.145-2.388,4.46,4.46,0,0,1,2.7-.835,4.342,4.342,0,0,1,2.64.8,2.606,2.606,0,0,1,1.088,2.232q0,1.922-3.106,3.63,1.553,1.9,2.524,2.912a7.109,7.109,0,0,0,.932-2.078l1.592,1.126a12.858,12.858,0,0,1-1.146,2.349q.776.8,1.98,1.922l-1.457,1.359-1.786-1.768A6.067,6.067,0,0,1,1483.7,1169.459Zm-1.688-2.436a3.188,3.188,0,0,0,1.961.553,4.216,4.216,0,0,0,2.6-1.126q-1.962-2.058-3.106-3.456-2.195,1.185-2.194,2.6A1.705,1.705,0,0,0,1482.016,1167.023Zm2.689-9.891a1.825,1.825,0,0,0-1.165.407,1.2,1.2,0,0,0-.515.951,1.873,1.873,0,0,0,.262.981,11.216,11.216,0,0,0,.9,1.213q2.194-1.087,2.194-2.019a1.34,1.34,0,0,0-.514-1.155A1.918,1.918,0,0,0,1484.7,1157.131Z",
    transform: "translate(-1479.123 -1155.403)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstructoraBaw);
export default __webpack_public_path__ + "static/media/logo-constructora-baw.5e4fe921b6ab4dc11eade0ba56d6c24d.svg";
export { ForwardRef as ReactComponent };